
<div class="container-fluid" >
  <div class="grid"  >
    <div class="col-4">
      @if ( !isManager && !mediatip.isReadonly && mediatip.mediatipState < 300 ) {
        <div class="grid  ">
          <label for="ean" class="col-12">EAN    </label>
          <div class="col-12">
            <p-inputgroup>
              <input [maxlength]="GetMaxLength(mediatip.ean)" id="ean" type="text" pInputText (keyup)="checkean()"
                [(ngModel)]="mediatip.ean" />
              <p-button type="button" icon="pi pi-times" pTooltip="Löschen"
              (onClick)="eanreset()"></p-button>
            </p-inputgroup>
          </div>
        </div>
      }
      @if (mediatip.ean && getEanError()) {
        <div class="grid">
          <div class="alert alert-warning"> {{getEanError()}}</div>
        </div>
      }
      <div class="grid">
        <div class="col-12">Titelinfo
          <hr />
        </div>
      </div>
      <div class="container-fluid grid p-row">
        <div class="col">
          @if ( mediatip.bubData && mediatip.bubData.ean && mediatip.bubData.ean.length==13) {
            <img class="bild"
              [src]='"https://produktbilder.paragon-data.net/" + mediatip.bubData.ean  + "_120x120.jpg?showDummy=true"'>
            }
          </div>
          <div class="col-8">
            <div class="grid p-row">
              <div class="col-12"><label>{{mediatip.bubData && mediatip.bubData.autor}}</label></div>
              <div class="col-12">{{mediatip.bubData && mediatip.bubData.titel}}</div>
              <div class="col-8">{{mediatip.bubData && mediatip.bubData.ean}}</div>
              <div class="col-4">{{mediatip.bubData && mediatip.bubData.warenGroup}}</div>
              <div class="col-12">{{mediatip.bubData && mediatip.bubData.verlag}}</div>
              <div class="col-8">{{mediatip.bubData && mediatip.bubData.preis}}@if (mediatip.bubData && mediatip.bubData.preis) {
                <span
                > €</span>
              }</div>
              <div class="col-4">{{mediatip.bubData && mediatip.bubData.erscheinung | date:"dd.MM.yyyy"}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-8">
        <div class="grid col-12">
          <div class="col-2">Präsenzen</div>
          <div class="col" style="width:50px"> @if (!mediatip.isReadonly || isManager) {
            <i
            class="pi pi-plus plusbutton" (click)="addEmptyMediaPresence(pt)"></i>
          }</div>
          <div class="col-2">&nbsp;</div>
          @if (!isManager) {
            <div class="col-6">
              <p-select [disabled]="mediatip.isReadonly"
                [options]="selectSomaContactData$ | async" class="dropdownSoma" [(ngModel)]="selectedLiPoContact"
                (onChange)="setLiPoContact(selectedLiPoContact)" optionLabel="friendlyName"
              placeholder="Sortimentsmanager wählen" appendTo="body"></p-select>
            </div>
          }
        </div>
        <div class="grid">
          <p-table #pt class="col-12" [value]="mediatip.mediaPresences" editMode="cell" showGridlines="true"
            [resizableColumns]="false" dataKey="id" [paginator]="true" [rows]="10" [scrollable]="false">
          <ng-template pTemplate="header">
            <tr>
              <th class="headerAction">&nbsp;</th>
              <th class="headerDatum">Datum</th>
              <th class="headerName">Name</th>
              <th class="headerArt">Art</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-rowData let-editing="editing" let-ri="rowIndex">
            <tr>
              <td class="cellAction">
                <p-button [disabled]="!canAction(rowData, 'löschen') || mediatip.isReadonly" pTooltip="Löschen"
                  severity="warn"
                  size="small"  icon="pi pi-trash"
                  (onClick)="deleteMediaPresence(rowData, ri)">
                </p-button>
              </td>

              <td pEditableColumn class="cellDatum">
                <p-cellEditor>
                  <ng-template pTemplate="input">

                    <p-datepicker [minDate]="minDatePrecense" [(ngModel)]="rowData.presenceDate" [firstDayOfWeek]="1"
                      [disabled]="!canEdit(rowData, 'presencedate') "
                      dateFormat="dd.mm.yy" appendTo="body" showButtonBar="true" [showIcon]="true" [disabled]="mediatip.isReadonly"
                    placeholder="Datum wählen"></p-datepicker>
                  </ng-template>
                  <ng-template pTemplate="output">
                    @if (!rowData.presenceDate) {
                      <span>Datum
                      wählen</span>
                      }{{ rowData.presenceDate | date:"dd.MM.yyyy" }}
                    </ng-template>
                  </p-cellEditor>
                </td>
                <td pEditableColumn class="cellName">

                  <p-cellEditor>
                    <ng-template pTemplate="input">
                      <p-select [filter]="true" [options]="settingsPresenceNames" [(ngModel)]="rowData.presence"
                        [disabled]="!canEdit(rowData, 'presence') " (onChange)="setPresenceName($event, ri, rowData)"
                        optionLabel="settingValue" placeholder="Präsenz wählen"
                        [style]="{ width: '100%', overflow: 'visible' }" appendTo="body">
                      </p-select>
                    </ng-template>
                    <ng-template pTemplate="output">
                      @if (!rowData.presence) {
                        <span>Präsenz wählen</span>
                        }{{ rowData.presence }}
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td pEditableColumn class="cellArt">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <p-select [filter]="true" [options]="settingsPresenceTypes" [(ngModel)]="rowData.presenceType"
                          [disabled]="!canEdit(rowData, 'presenceType') "
                          (onChange)="setPresenceType($event, ri, rowData)" optionLabel="settingValue"
                        placeholder="Art wählen" appendTo="body"></p-select>
                      </ng-template>
                      <ng-template pTemplate="output">
                        @if (!rowData.presenceType) {
                          <span>Art wählen</span>
                          }{{ rowData.presenceType }}
                        </ng-template>
                      </p-cellEditor>
                    </td>
                  </tr>
                  @if (hasError(mediatip, rowData)) {
                    <tr>
                      <td></td>
                      <td colspan="3">
                        <div [innerHTML]="getPresenceError(rowData)"></div>
                      </td>
                    </tr>
                  }
                </ng-template>
              </p-table>
            </div>
          </div>

        </div>


        @if (hasMediatipError(mediatip)) {
          <div class="grid">
            <div class="col-4">&nbsp;</div>
            <div class="col-8 alert alert-warning">
              <div [innerHTML]="getMediatipError(mediatip)"></div>
            </div>
          </div>
        }

        <div class="grid col-12">
          <div class="col-4">&nbsp;</div>
          <div class="col field">
            <label for="anmerkung">Anmerkung</label>
            <p-inputgroup>
              <textarea id="anmerkung" [style]="{'width':'100%'}" rows="3" autoResize="false" pTextarea [readOnly]="mediatip.isReadonly"
              [(ngModel)]="mediatip.remark">   </textarea>

              <p-button  type="button" icon="pi pi-times" pTooltip="Anmerkung löschen" [disabled]="mediatip.isReadonly"
              (onClick)="remarkreset()"></p-button>

            </p-inputgroup>
          </div>
        </div>




        <div class="grid">
          <div class="col-4">

          </div>
          @if (mediatip.isReadonly) {
            <div class="col-6">&nbsp;</div>
          }
          @if (mediatip.isReadonly) {
            <div class="col-2"><button pButton type="button" icon="pi pi-check" label="OK"
            style="padding-left: 15px;" (click)="cancel()"></button></div>
          }
          @if (!mediatip.isReadonly) {
            <div class="col-4"><button [disabled]="!canSaveandSubmit()"
              pButton type="button" icon="pi pi-check"
              [label]="isManager ? 'Speichern + Freigeben' : 'Speichern + Versenden' " style="padding-left: 15px;"
            (click)="saveAndSubmit()"></button></div>
          }
          @if (!mediatip.isReadonly) {
            <div class="col-2"><button [disabled]="!canSave()"
              pButton type="button" icon="pi pi-check" label="Speichern" style="padding-left: 15px;"
            (click)="save(false)"></button></div>
          }
          @if (!mediatip.isReadonly) {
            <div class="col-2"><button  pButton type="button"
            icon="pi pi-times" label="Abbrechen" style="padding-left: 15px;" (click)="cancel()"></button></div>
          }

        </div>


      </div>
